module.exports = __webpack_public_path__ + "static/media/italian-categories.845226cb.jpg";